import { Injectable } from '@angular/core';
import {
	HttpRequest,
	HttpHandler,
	HttpEvent,
	HttpInterceptor, HttpResponse
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { MyLogger } from 'src/shared/services/helpers/logging.service';

@Injectable()
export class ResponseConverterInterceptor extends MyLogger implements HttpInterceptor {

	constructor() {
		super('Paypal Interceptor')
	}

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		const started = Date.now();
		// this.log(req.url);
		// if (req.url.includes('https://www.paypal.com')) {
		// 	this.log(req.url);
		// }
		return next.handle(req).pipe(
			map(response => {
				let newResponse = response;
				if (response instanceof HttpResponse && req.url.includes('admin')) {
					const elapsed = Date.now() - started;
					// Todo add loger service
					const requestName = req.body ? req.body.operationName : 'mock-data';
					// console.log('response', response);
					if (response.body) {
						// response.body.data.timing = elapsed;
						newResponse = response.clone(response.body);
						// newResponse = response.body;
						// this.info(`${requestName} took ${elapsed} ms.`, response.body.data);
					} else {
						newResponse = response;
					}
				}
				// console.log('newResponse', newResponse);
				return response;
			})
		);
	}
}
